import ActivitesLayout from '@/layout/ActivitesLayout/index.vue'

const activitesMap = [
  // {
  //   path: '/activites',
  //   name: 'Activites',
  //   component: ActivitesLayout,
  //   redirect: '/activites/activites-home',
  //   children: [
  //     {
  //       path: '/activites/activites-home',
  //       name: 'ActivitesHome',
  //       component: () => import('@/views/activites'),
  //       meta: {
  //         name: '活动'
  //       },
  //     },
  //   ]
  // },
  {
    path: '/activites',
    name: 'Activites',
    component: () => import('@/views/acvities2/index.vue'),
    meta: {
      name: '活动',
      keepAlive: false
    }
  },
  {
    path: '/activites/game',
    name: 'ActivitesGame',
    component: () => import('@/views/acvities2/game/index.vue')
  }
]

export default activitesMap